import React, { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Experience from './components/Experience/Experience';
import Reviews from './components/Reviews/Reviews';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import { FaWhatsapp } from 'react-icons/fa';
import './styles/globals.css';
import './styles/variables.css';
import './App.css';

function App() {
  const [binaryColumns, setBinaryColumns] = useState([]);

  useEffect(() => {
    // Generate binary strings for each column
    const generateBinaryString = (length) => {
      let binary = '';
      for (let i = 0; i < length; i++) {
        binary += Math.random() > 0.5 ? '1' : '0';
        if (i % 10 === 9) binary += '\n'; // Add line break every 10 characters
      }
      return binary;
    };

    const columns = [];
    for (let i = 0; i < 10; i++) {
      columns.push(generateBinaryString(100));
    }
    setBinaryColumns(columns);

    // Update binary strings periodically
    const interval = setInterval(() => {
      const newColumns = [];
      for (let i = 0; i < 10; i++) {
        newColumns.push(generateBinaryString(100));
      }
      setBinaryColumns(newColumns);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <div className="background"></div>

      {/* Binary Rain Effect */}
      <div className="binary-rain">
        {binaryColumns.map((column, index) => (
          <div key={index} className="binary-column">
            {column}
          </div>
        ))}
      </div>

      <Header />
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Reviews />
      <Contact />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/963952347334"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
}

export default App;